import { render, staticRenderFns } from "./TaxReturnAdvancementsSection.vue?vue&type=template&id=7615415e&scoped=true&"
import script from "./TaxReturnAdvancementsSection.vue?vue&type=script&lang=js&"
export * from "./TaxReturnAdvancementsSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7615415e",
  null
  
)

export default component.exports